import EducationInfoContent from './EducationInfoContent';

export default EducationInfoContent;
